







































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import BusinessService from '@/api/BusinessService';

import flagKeys from '@/constants/flagKeys';

import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';

import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import RulePassword from '@/componentsV2/molecules/RulePassword/RulePassword.vue';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';

export type AccountFormData = {
  current_password: string;
  new_password: string;
};

import {
  minLenght,
  hasAtLeastNumber,
  hasAtLeastLetter
} from '@/utils/validationPassword';

import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    Input,
    FilledButton,
    RulePassword,
    ContentContainer,
    ValidationObserver,
    ValidationProvider,
    Typography,
    Page
  }
})
export default class ChangePassword extends Vue {
  managerService = new BusinessService();
  failedRulesPassword: string[] = [];
  loading = false;

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  form: AccountFormData = {
    current_password: '',
    new_password: ''
  };

  get isPasswordLengthValid() {
    return minLenght(this.form.new_password);
  }

  get isPasswordNumberValid() {
    return hasAtLeastNumber(this.form.new_password);
  }

  get isPasswordLetterValid() {
    return hasAtLeastLetter(this.form.new_password);
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get flagRulesPassword() {
    return this.flags.includes(flagKeys.enableRulesPassword);
  }

  clearFailedRulesPassword() {
    if (this.flagRulesPassword) {
      this.failedRulesPassword = [];
    }
    return;
  }

  clearFields() {
    const current_password = document.querySelector<HTMLInputElement>(
      '[name="current_password"]'
    )!;
    const new_password = document.querySelector<HTMLInputElement>(
      '[name="new_password"]'
    )!;

    this.form = {
      current_password: '',
      new_password: ''
    };

    current_password.value = '';
    new_password.value = '';
  }

  async submit() {
    const formRef = this.$refs.observer;
    const formIsValid = await formRef.validate();

    if (this.flagRulesPassword) {
      if (
        !this.isPasswordLengthValid ||
        !this.isPasswordNumberValid ||
        !this.isPasswordLetterValid
      ) {
        const failedRules = formRef.fields.password.failedRules;
        this.failedRulesPassword = Object.keys(failedRules);
        return null;
      }
    }

    if (!formIsValid) {
      setFocusOnFirstInput('input[aria-invalid="true"]');

      return;
    }

    const { current_password, new_password } = this.form;

    const payload = {
      password: current_password,
      newPassword: new_password
    };

    this.$showLoaderWithLocker();

    const response = await this.managerService.updateManager(payload);

    this.$hideLoader();

    if (response.status !== 200) return;

    this.clearFields();
    this.failedRulesPassword = [];
    this.loading = false;

    this.$notification('Password updated successfully!');
    segmentIo.track('Password updated');
  }

  mounted() {
    setFocusOnFirstInput();
  }
}
